import * as React from 'react'

import Svg, { G, Mask, Path } from 'react-native-svg'

import { IconProps } from '..'

const PrivacyAndPolicy = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <Mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <Path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </Mask>
    <G mask="url(#a)">
      <Path
        fill="#5FAFFF"
        d="M5 4v6.025V10v10V4Zm2 10h3.5c.15-.383.333-.742.55-1.075.217-.333.467-.642.75-.925H7v2Zm0 4h3.175a5.727 5.727 0 0 1-.15-2H7v2Zm-2 4c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 3 20V4c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 5 2h8l6 6v2.5a5.779 5.779 0 0 0-.975-.313A8.204 8.204 0 0 0 17 10.025V9h-5V4H5v16h6.025c.267.4.567.77.9 1.113a5.9 5.9 0 0 0 1.1.887H5Zm11.5-3c.7 0 1.292-.242 1.775-.725.483-.483.725-1.075.725-1.775s-.242-1.292-.725-1.775C17.792 14.242 17.2 14 16.5 14s-1.292.242-1.775.725C14.242 15.208 14 15.8 14 16.5s.242 1.292.725 1.775c.483.483 1.075.725 1.775.725Zm5.1 4-2.7-2.7a4.04 4.04 0 0 1-1.137.525c-.409.117-.83.175-1.263.175-1.25 0-2.313-.438-3.188-1.313C12.438 18.813 12 17.75 12 16.5c0-1.25.438-2.313 1.313-3.188C14.187 12.438 15.25 12 16.5 12c1.25 0 2.313.438 3.188 1.313C20.563 14.187 21 15.25 21 16.5c0 .433-.058.854-.175 1.262A4.04 4.04 0 0 1 20.3 18.9l2.7 2.7-1.4 1.4Z"
      />
    </G>
  </Svg>
)
export default PrivacyAndPolicy
